export default import.meta.ROLLUP_FILE_URL_owo1GFlk7ghFAvEx$YhdZA